function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import { Label } from './radioButtonElements';
import { ToggleCore } from '../../core-components/ToggleCore';
export const RadioButton = /*#__PURE__*/forwardRef(({
  label,
  className,
  ...props
}, fRef) => /*#__PURE__*/React.createElement(Label, {
  "data-aui": "radio-button",
  className: className
}, /*#__PURE__*/React.createElement(ToggleCore, _extends({
  toggleType: "radio",
  ref: fRef
}, props), label)));